var map = {
	"./_base-breadcrumbs.vue": 40898,
	"./_base-button-genre.vue": 71699,
	"./_base-button-play.vue": 33394,
	"./_base-button.vue": 11040,
	"./_base-card-link.vue": 48607,
	"./_base-card.vue": 51687,
	"./_base-content.vue": 42657,
	"./_base-custom-select.vue": 65184,
	"./_base-dots.vue": 98719,
	"./_base-dropdown.vue": 9356,
	"./_base-empty-list.vue": 22697,
	"./_base-favourites.vue": 23471,
	"./_base-hero-background.vue": 59901,
	"./_base-hero.vue": 46419,
	"./_base-icon.vue": 36711,
	"./_base-input.vue": 22859,
	"./_base-link.vue": 76682,
	"./_base-load-more.vue": 73903,
	"./_base-placeholder.vue": 70023,
	"./_base-resource-cover.vue": 47389,
	"./_base-resource-image.vue": 65185,
	"./_base-search-input.vue": 50626,
	"./_base-section.vue": 61888,
	"./_base-select.vue": 45830,
	"./_base-spinner.vue": 29216,
	"./_base-tab-list.vue": 46983,
	"./_base-tab-panel.vue": 84850,
	"./_base-tab.vue": 62311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28957;